import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { SearchOutlined } from '@ant-design/icons'
import { Button, Input } from 'antd'
import useParams from '../../hook/useParams'
import { SearchWrapper, WhiteWrapper } from './dashboard.styled'
import { useSelector } from 'react-redux'
import MainTable from '../../components/Basic/MainTable'
import { fetchBrandList } from '../../apis/brand'
import { fetchGroupList } from '../../apis/group'

function DashboardAdmin (props) {
  const { adminMode } = props
  const { t: ln_t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const { pathname } = location || {}
  const user = useSelector((state) => state.user)
  const { nowGroup } = user || {}
  const params = useParams({ includes: 'group', groupId: adminMode ? undefined : nowGroup })
  const { handleFetchParams, fetchParams } = params

  const [searchVal, setSearchVal] = useState()
  const [groupList, setGroupList] = useState([])

  const linkBtnStyle = { cursor: 'pointer', color: 'var(--primary)' }
  const apiFunc = async () => fetchBrandList(fetchParams)
  const columns = [
    { title: ln_t('dashboard.brand'), dataIndex: 'name', sorter: true },
    ...adminMode
      ? [{
          title: ln_t('dashboard.group'),
          dataIndex: 'groupId',
          render: (e, data) => data?.group?.name || '-',
          filters: groupList,
          filterMultiple: false
        }]
      : [],
    // {
    //   title: ln_t('dashboard.groupDashboard'),
    //   dataIndex: 'id',
    //   render: (id, data) => <div style={linkBtnStyle} onClick={() => navigate(`${pathname}/groupDashboardSetting`, { state: { data } })}>{ln_t('dashboard.setting')}</div>
    // },
    {
      title: ln_t('dashboard.brandDashboard'),
      dataIndex: 'id',
      render: (id, data) => <div style={linkBtnStyle} onClick={() => navigate(`${pathname}/brandDashboardSetting`, { state: { data } })}>{ln_t('dashboard.setting')}</div>
    },
    {
      title: ln_t('dashboard.segmentPreview'),
      dataIndex: 'id',
      render: (id, data) => <div style={linkBtnStyle} onClick={() => navigate(`${pathname}/segmentSetting`, { state: { data } })}>{ln_t('dashboard.setting')}</div>
    },
    {
      title: ln_t('consumer.consumer360'),
      dataIndex: 'id',
      render: (id, data) => <div style={linkBtnStyle} onClick={() => navigate(`${pathname}/consumer360Setting`, { state: { data } })}>{ln_t('dashboard.setting')}</div>
    }
  ]

  const getGroups = async () => {
    const res = await fetchGroupList({})
    if (res?.status === 200) setGroupList(res?.data?.map(i => ({ value: i.id, text: i.name })))
  }
  useEffect(() => { if (adminMode) getGroups() }, [])

  return (
    <WhiteWrapper>
      <h3>{ln_t('dashboard.dashboard')} & {ln_t('consumer.consumer360')} {ln_t('dashboard.setting')}</h3>
      <SearchWrapper>
        <Input.Search
          allowClear
          style={{ width: '400px' }}
          placeholder={ln_t('util.search')}
          value={searchVal}
          onChange={e => setSearchVal(e?.target?.value)}
          onSearch={e => handleFetchParams('add', { name_like: `%${e}%` })}
          enterButton={<Button type="primary" size="small" icon={<SearchOutlined />} />}
        />
      </SearchWrapper>

      <MainTable
        columns={columns}
        rowKey="id"
        apiFunc={apiFunc}
        params={params}
        disabledRow={record => !record.previewCount || !record.status}
      />
    </WhiteWrapper>
  )
}

export default DashboardAdmin
